import React from "react";
import { Button } from "@mui/material";
import { motion } from "framer-motion";

const OcrButton = ({ handleSubmit, disabled, isLoading }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.8 }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={disabled || isLoading}
        sx={{
          mt: 1,
          px: 4,
          py: 1.5,
          borderRadius: 999,
          color: "#ffffff !important",
          textTransform: "none",
          fontWeight: 700,
          fontSize: "1rem",
          background: "linear-gradient(135deg, #006d77 0%, #0b8f87 100%)",
          boxShadow: "0 18px 36px rgba(0, 109, 119, 0.24)",
          "&:hover": {
            background: "linear-gradient(135deg, #015c64 0%, #087f78 100%)",
          },
        }}
      >
        {isLoading ? "Submitting..." : "Start OCR"}
      </Button>
    </motion.div>
  );
};

export default OcrButton;
